import { render, staticRenderFns } from "./CadastroEmpresaCopiarButton.vue?vue&type=template&id=d073af26&scoped=true"
import script from "./CadastroEmpresaCopiarButton.vue?vue&type=script&lang=js"
export * from "./CadastroEmpresaCopiarButton.vue?vue&type=script&lang=js"
import style0 from "./CadastroEmpresaCopiarButton.vue?vue&type=style&index=0&id=d073af26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d073af26",
  null
  
)

export default component.exports